var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.img)?_c('img',{staticClass:"verification-code",attrs:{"src":_vm.img},on:{"click":_vm.doChanges}}):_vm._e(),_c('span',{on:{"click":_vm.doChanges}},[_vm._v(_vm._s(_vm.L("换一换")))])])}
var staticRenderFns = []

export { render, staticRenderFns }